import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ResizeSensor from 'resize-sensor'
import uniqueKeyGenerator from './external/UniqueKeyGenerator'

class TextEllipsis extends Component {
  // required props are: fontSize, maxLines, textAlign, rgbBgColor, shouldntClamp
  static propTypes = {
    fontSize: PropTypes.number.isRequired,
    maxLines: PropTypes.number.isRequired,
    textAlign: PropTypes.string,
    rgbBgColor: PropTypes.string.isRequired,
    shouldntClamp: PropTypes.bool,
    children: PropTypes.any.isRequired
  };

  state = {
    shouldEllipse: false,
    key: uniqueKeyGenerator()
  };
  componentDidMount () {
    if (!this.props.shouldntClamp) {
      const text = document.getElementById('ellipsisText' + this.state.key);
      this.setState({ shouldEllipse: text.clientHeight > this.props.maxLines * this.props.fontSize * 1.5 });
      this.resizeSensor = new ResizeSensor(text, () => {
        this.setState({ shouldEllipse: text.clientHeight > this.props.maxLines * this.props.fontSize * 1.5 });
      })
    }
  }
  componentWillUnmount () {
    if (this.resizeSensor) {
      this.resizeSensor.detach();
    }
  }

  render() {
    const styles = {
      ellipsisWrapper: {
        padding: 0,
        margin: 0,
        maxHeight: this.props.shouldntClamp ? null : Math.floor(this.props.maxLines * this.props.fontSize * 1.5),
        position: 'relative',
        overflow: 'hidden'
      },
      ellipsisText: {
        fontSize: this.props.fontSize,
        textAlign: this.props.textAlign || 'justify',
        lineHeight: 1.5,
        padding: 0,
        margin: 0,
        color: 'inherit'
      },
      ellipsisSign: {
        height: this.props.fontSize * 1.5,
        display: 'flex',
        position: 'absolute',
        right: 0,
        bottom: 0,
        zIndex: 1
      },
      ellipsisFade: {
        height: this.props.fontSize * 1.5,
        width: this.props.fontSize * 1.5,
        background: `linear-gradient(to right, rgba(255, 255, 255, 0), ${this.props.rgbBgColor})`
      }
    };

    const ellipsis = (
      <span style={styles.ellipsisSign}>
        <div style={styles.ellipsisFade} />
        <div style={{backgroundColor: this.props.rgbBgColor}}>...</div>
      </span>)
    ;

    const shouldShowEllipsis = (component) => {
      if (this.props.shouldntClamp) return null;
      else if (this.state.shouldEllipse) return component;
      else return null;
    };

    return (
      <div style={styles.ellipsisWrapper}>
        {shouldShowEllipsis(ellipsis)}
        <div id={'ellipsisText' + this.state.key} style={styles.ellipsisText}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default TextEllipsis;
